

.primaryColumn  {
  height: 100%;
  padding-bottom: 2rem;
}

.orange {
  color: var(--color-primary);
}